export default "__VITE_ASSET__bdc385b2__"